module.exports = __webpack_public_path__ + "static/media/toy_mono.ecdec293.mp3";